import { useEffect, useMemo, useState } from 'react';
import { Cascader, Col, Row } from 'antd';
import CustomSelector from 'components/common/Selector';
import { useItemModifiers } from 'graphql/useItemExtras';
import ArrowDown from 'components/icons/ArrowDown';
import Colors from 'assets/Colors';

import { useTranslation } from 'react-i18next';
import s from './styles';

function Modifiers({ setFieldValue, values }) {
  const { t } = useTranslation();
  const itemExcluid =
    values?.modifierConfig?.excludeList?.map((item) => item) || [];

  const { itemModifiers } = useItemModifiers();

  const [modifiers, setModifiers] = useState(values?.modifierConfig?._id || []);
  const [modifierItem, setModifierItem] = useState(itemExcluid);

  const dataModifiers = itemModifiers.map((modifier) => ({
    value: modifier._id,
    name: modifier.name,
    modifiers: modifier.modifiers.map((modifierItem) => ({
      value: modifierItem._id,
      label: modifierItem.name,
    })),
  }));

  const dataModifiersItems = useMemo(() => dataModifiers?.filter((modifier) => modifier.value == modifiers), [dataModifiers, modifiers]);

  dataModifiers.unshift({
    name: t('components.InventoryItems.AddItem.Modifiers.none'),
    value: null,
  });

  useEffect(() => {
    if (
      modifiers === t('components.InventoryItems.AddItem.Modifiers.textAddItem')
    ) {
      setFieldValue('modifierConfig', undefined);
    }
  }, [modifiers, setFieldValue]);

  return (
    <s.Wrapper>
      <s.SectionTitle>
        <s.Title>{t('Items.fields.modifierConfig.title')}</s.Title>
      </s.SectionTitle>
      <s.Line style={{ marginBottom: '10px' }} />

      <Row gutter={61}>
        <Col xs={24} md={12}>
          <s.text>{t('Items.fields.modifierConfig.addModifier')}</s.text>
          <CustomSelector
            borderColor="#959faf"
            options={dataModifiers}
            style={{ width: '100%' }}
            placeholder={t(
              'Items.fields.modifierConfig.addModifierPlaceholder'
            )}
            value={modifiers}
            onChange={(value) => [
              setModifiers(value),
              setModifierItem([]),
              setFieldValue(
                'modifierConfig',
                value == null ? null : { _id: value }
              ),
            ]}
          />
        </Col>
        <Col xs={24} md={12}>
          <s.text>{t('Items.fields.modifierConfig.excludeModifier')}</s.text>
          <Cascader
            bordered={false}
            suffixIcon={<ArrowDown />}
            disabled={!modifiers?.length}
            dropdownMenuColumnStyle={{ background: 'white', height: 'auto' }}
            placeholder={t(
              'Items.fields.modifierConfig.excludeModifierPlaceholder'
            )}
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              border: `0.5px solid ${Colors.background_dividers}`,
              borderRadius: '2px',
              height: '40px',
              fontSize: '12px',
              width: '100%',
              color: Colors.text_primary,
            }}
            defaultValue={
                modifierItem?.length > 0
                  ? modifierItem?.map((item) => [item])
                  : null
              }
            value={
                modifierItem?.length > 0
                  ? modifierItem?.map((item) => [item])
                  : null
              }
            options={dataModifiersItems[0]?.modifiers}
            onChange={(value) => [
              setModifierItem(value),
              setFieldValue('modifierConfig', {
                ...values.modifierConfig,
                excludeList: value.map((val) => val[0]),
              }),
            ]}
            multiple
            maxTagCount="responsive"
          />
        </Col>
      </Row>
    </s.Wrapper>
  );
}

export default Modifiers;
